/*
 * @Descripttion:
 * @version:
 * @Author: TangXihao
 * @Date: 2021-03-08 11:11:44
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-04-19 09:18:16
 */
import React, { Fragment, useState } from 'react'
import { DraggableArea } from 'react-draggable-tags';
import './index.css'
import { Button, Input, message, Modal, Pagination, Form } from 'antd'
import axios from 'axios'
import Header4 from '../../Header/Header4'
import Base64 from "base-64"
import { ClockCircleOutlined, EditOutlined } from "@ant-design/icons";
import { Breadcrumb, Spin } from "antd";
import PDFViewer from "react-pdf-js";
import FileViewer from "react-file-viewer"

class GuideSearch extends React.Component {
    state = {
        activetype: 0,
        result: [],
        searchvalue: '',
        author: '',//作者
        activeTypeData: [],
        initialTags: [],
        fristFlag: true,
        currentIndex: 1,
        totalSize: 0,
        limitCount: 5,
        nowClickFile: undefined,//当前点击的文件
        preLookModalFlag: false,
        showDetail: false,
        currentPage: 1,
        activeUrl: '',
        activeTitle: "",
        isLoading: false,//用于控制当前列表页面是否处于加载状态
    }

    componentDidMount() {
        this.getAllKnowledgeBase();
        let searchvalue = this.props.location.state ? this.props.location.state.searchvalue : '';
        this.setState({ searchvalue });
    }

    /**
     * 获取首次进入页面的左侧导航栏和第一页数据
     */
    getAllKnowledgeBase = () => {

        axios.get(global.url.knowledgeBase + `/class/get`,).then(res => {
            console.log("getAllKnowledgeBase-----", res.data);
            if (res.data.code === "200") {
                let data = res.data.payload;
                if (data.length >= 1) {
                    this.getDataByType(data[0], 1)
                }
                this.setState({
                    initialTags: [...data],
                })
            } else {
                message.error("目录检索失败，请检查网络连接……")
            }
            this.setState({ spinning: false });

        }).catch((e) => {
            message.error("目录检索失败，请检查网络连接……")
            console.log(e);
            this.setState({ spinning: false });
        })
    }

    /**
     * 根据所选类型获取数据
     * @param {string} tagItem
     * @param {number} page
     */
    getDataByType = (tagItem, page) => {
        this.setState({ activetype: tagItem });
        let keyword = this.state.searchvalue === undefined || this.state.searchvalue === '' ? '' : `&keyWord=${this.state.searchvalue}`;
        let author = this.state.author === undefined || this.state.author === '' ? '' : `&author=${this.state.author}`;
        console.log('searchvalueIs"":', this.state.searchvalue);
        axios.get(global.url.knowledgeBase + `/imagedata/getimagedata?className=${tagItem.name}&limit=${this.state.limitCount}&page=${page}` + `${keyword}` + `${author}`).then(r => {
            if (r.data.code === '200') {
                this.setState({
                    activeTypeData: r.data.payload.records,
                    totalSize: r.data.payload.total,
                    isLoading: false
                });
            } else {
                message.error("检索失败，请检查网络连接……");
            }
        }).catch(e => {
            message.error("检索失败，请检查网络连接……");
            console.log(e);
        });
    }


    /**
     * 单击搜索后查询数据
     * @param {string} clear -特殊标记，用于检查搜索框是否为空，若为空则直接查询默认数据
     */
    searchKnowledge = (clear) => {
        console.log('clear:', clear);
        const { searchvalue, activetype, limitCount } = this.state;
        let keyword;
        if (clear === 'back') {
            keyword = '';
        } else {
            keyword = searchvalue === '' ? '' : `&keyWord=${searchvalue}`;
        }
        let author = this.state.author === undefined || this.state.author === '' ? '' : `&author=${this.state.author}`;
        axios.get(global.url.knowledgeBase + `/imagedata/getimagedata?className=${activetype.name}&limit=${limitCount}&page=${1}` + `${keyword}` + `${author}`).then(r => {
            if (r.data.code === '200') {
                this.setState({ activeTypeData: r.data.payload.records, isLoading: false })
            }
        })
    }

    /**
     * 用于改变状态打开详情预览界面
     * @param {string} curUrl -资源的url
     * @param {string} curTitle -资源题目
     */
    handleOpenDetail = (curUrl, curTitle) => {
        this.setState({ showDetail: true, activeUrl: curUrl, activeTitle: curTitle });
    }

    /**
     * 用于加载资源列表卡片
     * @returns {Element[]}
     */
    loadDataByType = () => {
        let res = [];
        if (this.state.activeTypeData.length) {
            res = this.state.activeTypeData.map(data => <div
                key={data.id}
                onClick={() => this.handleOpenDetail(data.annex, data.title)}
                className="info_item info_item_coverage">
                <img className="info_image" src={data.imageUrl} alt={"图片正在加载中"} />
                <div className="info_content">
                    <div
                        className="info_title">{data.title.slice(0, 25)}{data.title.length <= 25 ? null : '…'}</div>
                    <div
                        className="info_introduce">{data.summary.length <= 128 ? data.summary : data.summary.slice(0, 126) + '……'}</div>
                    <div className="info_source">
                        <EditOutlined style={{ color: "green" }} />
                        {data.author}
                    </div>
                    <div className="info_source">
                        <ClockCircleOutlined style={{ color: "brown" }} />
                        {data.time}
                    </div>
                </div>
            </div>);
        }
        return res;
    }

    render() {
        const { currentPage, nowClickFile, totalSize, limitCount, preLookModalFlag } = this.state;
        return (<>
            <Header4></Header4>
            <div className='guide-searchresult-backpanel'>
                <div className='guide-searchpanel'>
                </div>
                <div className='guide-search-contentpanel'>
                    <div className="catalog_panel">
                        <div className="left_header">
                            <div className="right_header_font">知识库目录</div>
                        </div>
                        <div className='guide-search-result-menu' ref="Box2" id="guideSearch_menu">
                            <DraggableArea
                                tags={this.state.initialTags}
                                render={
                                    ({ tag, index }) => (
                                        <div
                                            className={`guide-search-result-menuitem ${this.state.activetype.name === tag.name && 'guide-search-result-menuitem-active'}`}
                                            onClick={() => {
                                                this.setState({ showDetail: false, isLoading: true });
                                                this.getDataByType(tag, 1);
                                            }}>
                                            <div
                                                className='guide-search-result-menuitem-text'
                                                title={tag.name}>
                                                {tag.name}
                                            </div>
                                            <div className='guide-search-result-menu-arrow'>
                                            </div>
                                        </div>
                                    )
                                }
                                onChange={tags => {
                                    this.setState({ initialTags: tags })
                                }}
                            />
                        </div>
                    </div>
                    <div className='guide-search-result-resultpanel'>
                        <div className="right_header">
                            <div className="right_header_font">
                                {!this.state.showDetail ? this.state.activetype.name : <Breadcrumb>
                                    <Breadcrumb.Item className="bread_crumb bread_crumb_hoverable"
                                        onClick={() => this.setState(prevState => {
                                            return { showDetail: !prevState.showDetail };
                                        })}>
                                        {this.state.activetype.name}
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item>{this.state.activeTitle}</Breadcrumb.Item>
                                </Breadcrumb>}
                            </div>
                        </div>
                        {this.state.showDetail ? <>
                            <FilePreView filePath={this.state.activeUrl} />
                        </> : <>
                            <div className="guide_search_panel">
                                <Form layout="inline">
                                    <Form.Item label="关键字">
                                        <Input className='guide_search_input' onPressEnter={this.searchKnowledge}
                                            value={this.state.searchvalue}
                                            onChange={(e) => {
                                                if (e.target.value === '') {
                                                    console.log(true);
                                                    this.searchKnowledge('back');
                                                }
                                                this.setState({ searchvalue: e.target.value });
                                            }}
                                            placeholder={'请输入'}>
                                        </Input>
                                    </Form.Item>
                                    <Form.Item label="作者">
                                        <Input className='guide_search_input' onPressEnter={this.searchKnowledge}
                                            value={this.state.author}
                                            onChange={(e) => {
                                                this.setState({ author: e.target.value });
                                            }}
                                            placeholder={'请输入'}>
                                        </Input>
                                    </Form.Item>
                                    <Form.Item>
                                        <Button className='guide_search_button' onClick={this.searchKnowledge}>搜索</Button>
                                    </Form.Item>
                                </Form>

                            </div>
                            <div className="right_body">
                                <Spin spinning={this.state.isLoading} tip={"数据正在加载中"}>
                                    {this.loadDataByType()}
                                </Spin>
                            </div>
                            <div className='guide-search-result-pagnationpanel'>
                                <Pagination size='middle'
                                    total={totalSize}
                                    pageSize={limitCount}
                                    className='guide-search-result-pagination'
                                    showSizeChanger={false}
                                    defaultCurrent={1}
                                    current={currentPage}
                                    onChange={this.changeCurrentPage}
                                ></Pagination>
                            </div>
                        </>}
                    </div>
                    {/*<div className='guide-search-result-pagnationpanel'>*/}
                    {/*</div>*/}
                </div>
                <Modal className="Filedownload_Modal" visible={preLookModalFlag} footer={null} title={"预览"}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ preLookModalFlag: false })} width={"80vw"}>
                    {nowClickFile ? <Fragment>
                        <div className='Filedownload_Modal_Content'>
                            <iframe id="Filedownload_Modal_Iframe" className='Filedownload_Modal_Iframe'
                                src={this.returnUrl(nowClickFile.content)} />
                        </div>
                    </Fragment> : <div className="Filedownload_Modal_Empty">暂无内容</div>}
                </Modal>
            </div>
        </>)
    }

    changeNowClickFile = (file) => {
        const { activetype } = this.state;
        let fileData = {
            ...file
        };
        if (activetype.id === "1583342072048828418") {
            fileData = {
                fileName: file.chsname, content: file.algorithmna,
            }
        }
        this.setState({
            preLookModalFlag: true, nowClickFile: fileData,
        });
    }

    //打开预览
    openPreLook = (text, file) => {
        console.log("openPreLook", text, file);
        this.setState({ preLookModalFlag: true, nowClickFile: file });
    }
    //返回预览链接
    returnUrl = (resourceUrl) => {
        // console.log("resourceUrl", resourceUrl);
        let region = /caplos.aircas.ac.cn\/\/?oss/;
        let newResource = '';
        let fileType = resourceUrl.split('.').splice(-1)[0];
        let imageType = ['png', 'jpg', 'jpeg'];
        // kkFile组件预览图片时需要外网的地址，预览文件时需要内网的地址
        if (imageType.includes(fileType)) {
            newResource = resourceUrl;
        } else {
            newResource = resourceUrl.replace(region, global.filePrevUrl);
            newResource = newResource.replace('https', 'http');
        }
        // newResource = resourceUrl.replace(region, global.filePrevUrl);
        // // let newResource = "http://124.16.188.131:9599/oss/group1/M00/00/7C/rBIAAWTMl3SAWKQqADrSJjhCqQc621.mp4";
        console.log("zyg")
        console.log("newResource:", newResource, `${global.support.filePreview}/onlinePreview?url=${Base64.encode(newResource)}`);
        console.log("knowlageBaseResourceUrl:", resourceUrl);
        return `${global.support.filePreview}/onlinePreview?url=${Base64.encode(newResource)}`;
    }
}


/**
 * 资源预览详情页面
 * @param {string} filePath -资源文件URL
 * @returns {Element}
 * @constructor
 */
function FilePreView({ filePath }) {
    const [pageNum, setPageNum] = useState(0);
    const [curPage, setCurPage] = useState(1);
    // let fileType = filePath.split('.').slice(-1)[0];
    const getPrevUrl = (resourceUrl) => {
        // console.log("resourceUrl", resourceUrl);

        let region = /caplos.aircas.ac.cn\/\/?oss/;
        let newResource = '';
        let fileType = resourceUrl.split('.').splice(-1)[0];
        let imageType = ['png', 'jpg', 'jpeg'];
        // kkFile组件预览图片时需要外网的地址，预览文件时需要内网的地址
        if (imageType.includes(fileType)) {
            newResource = resourceUrl;
        } else {
            newResource = resourceUrl.replace(region, global.filePrevUrl);
            newResource = newResource.replace('https', 'http');
        }
        // let newResource = "http://124.16.188.131:9599/oss/group1/M00/00/7C/rBIAAWTMl3SAWKQqADrSJjhCqQc621.mp4";
        console.log('文件原路径：', newResource);
        console.log('文件预览接口路径：', `${global.support.filePreview}/onlinePreview?url=${Base64.encode(newResource)}`);
        // console.log("newResource:", newResource, `${global.support.filePreview}/onlinePreview?url=${Base64.encode(newResource)}`);
        // console.log("knowlageBaseResourceUrl:", resourceUrl);
        return `${global.support.filePreview}/onlinePreview?url=${Base64.encode(newResource)}`;
    }


    return (<div className="file_preview_box">
        {/* {fileType === 'pdf' ? <>
            <PDFViewer file={filePath}
                onDocumentComplete={(pageNum) => setPageNum(pageNum)}
                page={curPage}
                fileType={fileType}
            />
            <Pagination simple={true} current={curPage} total={pageNum} pageSize={1} defaultCurrent={1}
                onChange={(page) => setCurPage(page)} />
        </> : <>
            <FileViewer
                fileType={fileType}
                filePath={filePath}
                // onError={this.onError}
                errorComponent={Error}
                unsupportedComponent={Error} />
        </>}*/}
        <iframe className="file_preview_window" src={getPrevUrl(filePath)}></iframe>
    </div>)
}

class Result_Data extends React.Component {
    render() {
        return <div className='guide-search-result-entity-data'>
            <div className='guide-search-result-entity-title'
                onClick={() => this.props.changeNowClickFile(this.props.data)}>
                {this.props.data.title}
            </div>
            <div className='guide-search-result-entity-content'>
                <div className='guide-search-result-entity-abstract'>
                    {this.props.data.detail}
                </div>
                <div className='guide-search-result-entity-source'>
                    {'来源:' + this.props.data.source}
                </div>
            </div>
        </div>
    }
}

class Result_News extends React.Component {
    render() {
        return <div className='guide-search-result-entity-data'>
            <div className='guide-search-result-entity-title'>
                {this.props.data.title}
            </div>
            <div className='guide-search-result-entity-content'>
                <div className='guide-search-result-entity-abstract'>
                    {'摘要:' + this.props.data.abstract}
                </div>
                <div className='guide-search-result-entity-source'>
                    {'来源:' + this.props.data.source}
                </div>
            </div>
        </div>
    }
}

class Result_KnowledgeBase extends React.Component {
    render() {
        return <div className='guide-search-result-entity-data'>
            <div className='guide-search-result-entity-title'>
                {this.props.data.title}
            </div>
            <div className='guide-search-result-entity-content'>
                <div className='guide-search-result-entity-detail-panel'>
                    <div className='guide-search-result-entity-detail-1'>
                        {'样品名称:' + this.props.data.abstract}
                    </div>
                    <div className='guide-search-result-entity-detail-2'>
                        {'方位角:' + this.props.data.fwj}
                    </div>
                    <div className='guide-search-result-entity-detail-3'>
                        {'入射角：' + this.props.data.rsj}
                    </div>
                    <div className='guide-search-result-entity-detail-4'>
                        {'波段：' + this.props.data.bd}
                    </div>
                </div>

                <div className='guide-search-result-entity-source'>
                    {'测量日期：' + this.props.data.date}
                </div>
            </div>
        </div>
    }
}

class Result_Forum extends React.Component {
    render() {
        return <div className='guide-search-result-entity-data'>
            <div className='guide-search-result-entity-title'>
                {this.props.data.title}
            </div>
            <div className='guide-search-result-entity-content'>
                <div className='guide-search-result-entity-abstract'>
                    {this.props.data.detail}
                </div>
                <div className='guide-search-result-entity-user'>
                    <img src={this.props.data.user.avatar} className={'guide-search-result-entity-user-avatar'}></img>
                    {this.props.data.user.userName}
                    <div className='guide-search-result-entity-forumtime'>
                        {this.props.data.time}
                    </div>
                </div>
            </div>
        </div>
    }
}

class Result_Arithmetic extends React.Component {
    render() {
        return <div className='guide-search-result-entity-data'>
            <div className='guide-search-result-entity-title'
                onClick={() => this.props.changeNowClickFile(this.props.data)}>
                {this.props.data.chsname}
            </div>
            <div className='guide-search-result-entity-content'>
                <div className='guide-search-result-entity-abstract'>
                    {`类型：${this.props.data.artificial}`}
                </div>
                <div className='guide-search-result-entity-score'>
                    {`评分：${this.props.data.score}`}
                </div>
            </div>
        </div>
    }
}

class Result_None extends React.Component {
    render() {
        return <div className='guide-search-result-none'>
            {'暂无结果...'}
        </div>
    }
}

export default GuideSearch